import { render, staticRenderFns } from "./moreOptions.vue?vue&type=template&id=af74effc&"
import script from "./moreOptions.vue?vue&type=script&lang=js&"
export * from "./moreOptions.vue?vue&type=script&lang=js&"
import style0 from "./moreOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports